import router, {
    staticRoutes,
    asyncRoutes
} from '@/router'
import {
    getToken,
    setToken,
    removeToken
} from '@/utils/auth'
import api from '@/api'

// 是否有路由权限
function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        roles.forEach(role => {
            return route.meta.roles.includes(role)
        })
        return false
    } else {
        return true
    }
}

// 递归获取有权限的路由
export function filterAsyncRoutes(routes, roles) {
    const res = []
    routes.forEach(route => {
        const tmp = {
            ...route
        }
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    })
    return res
}
//定义User模块
const user = {
    namespaced: true,
    state: {
        token: getToken(), // token
        userId: '', // 用户ID
        userName: '', // 用户名
        nickName: '', // 昵称
        avatar: '', // 头像
        email: '', // 邮箱
        loginDate: '', // 登录时间
        phonenumber: '', // 手机号码
        remark: '', // 备注
        roleIds: '', // 角色ID
        sex: '', // 性别， 1男，2女
        admin: false, // 是否是管理员
        createTime: '', // 创建时间
        createBy: '', // 创建者
        roles: [], // 角色
        permissions: [], // 权限
        routes: [], // 路由
        auth: '', // 认证

    },
    mutations: {
        updateInfo(state, res) {
            const {
                roles,
                user,
                permissions
            } = res
            state.userId = user.userId;
            state.userName = user.userName
            state.nickName = user.nickName
            state.avatar = user.avatar
            state.email = user.email
            state.phonenumber = user.phonenumber
            state.loginDate = user.loginDate
            state.remark = user.remark
            state.roleIds = user.roleIds
            state.sex = user.sex
            state.admin = user.admin
            state.createTime = user.createTime
            state.permissions = permissions
            state.roles = roles
        },

        updateAvatar(state, avatar) {
            state.avatar = avatar
        },
        updatePhone(state, phonenumber) {
            state.phonenumber = phonenumber
        },
        updateAuth(state, data) {
            state.auth = data
        },
        updateToken(state, token) {
            if (token && token.length) {
                setToken(token)
            } else {
                removeToken()
            }
            state.token = getToken()
        },
        deleteInfo(state) {
            state.userId = 0
            removeToken()
        },
        setAsyncRoutes(state, routes) {
            state.routes = staticRoutes.concat(routes)
        }
    },
    actions: {
        // 更新用户信息
        updateInfo({
            commit
        }, user) {
            commit('updateInfo', user)
        },
        updateAvatar({
            commit
        }, avatar) {
            commit('updateAvatar', avatar)
        },
        updatePhone({
            commit
        }, data) {
            commit('updatePhone', data)
        },
        updateAuth({
            commit
        }, data) {
            commit('updateAuth', data)
        },
        // 更新token
        updateToken({
            commit
        }, token) {
            commit('updateToken', token)
        },
        // 退出登录
        logout({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                if (state.token == undefined || state.token.length == 0) {
                    commit('deleteInfo')
                    resolve()
                } else {
                    api.user.logout()
                        .then(res => {
                            commit('deleteInfo')
                            resolve()
                        })
                        .catch(res => {
                            commit('deleteInfo')
                            reject()
                        })
                }
            })
        },
        // 获取路由
        getRouteList({
            commit,
            state
        }) {
            // console.log("获取", state);
            return new Promise(resolve => {
                // 已获取用户信息
                if (state.userId.length > 0) {
                    let routes = filterAsyncRoutes(asyncRoutes, state.roles)
                    commit('setAsyncRoutes', routes)
                    resolve(routes)
                } else {
                    // 先获取用户信息
                    api.user.getInfo()
                        .then(res => {
                            commit('updateInfo', res)
                            let routes = filterAsyncRoutes(asyncRoutes, state.roles)
                            commit('setAsyncRoutes', routes)
                            resolve(routes)
                        })
                        .catch(err => {
                            // 获取失败,重新登录
                            commit('deleteInfo')
                            router.replace({
                                path: '/login',
                            });
                        })

                    api.user.Getidentity()
                        .then(res => {
                            if (!res.data) {
                                commit("updateAuth", 1);
                                let routes = filterAsyncRoutes(asyncRoutes, state.roles)
                                commit('setAsyncRoutes', routes)
                                resolve(routes)
                            } else {
                                commit('updateAuth', res.data.auditStatus);
                                let routes = filterAsyncRoutes(asyncRoutes, state.roles)
                                commit('setAsyncRoutes', routes)
                                resolve(routes)
                            }
                        })
                        .catch(res => {
                            commit("updateAuth", 1);
                        })

                }
            })
        },
    }
};
//导出模块
export default user;